import MyModal from '../../components/Modal/Modal';
import styled from 'styled-components';
import { Form, TextInput, Button, Loading, PasswordInput, Select, Checkbox } from 'carbon-components-react';
import { toaster } from '../../helpers/toaster';
import {useState, useEffect} from 'react';
import ArrayInput from '../../components/ArrayInput/ArrayInput';
// import FieldGroupArray from '../StudyDetails/DetailSections/detailConneX/FieldGroupArray';
import SelectLabel from '../../components/SelectLabel';
const ClientDetailModal = ({
  mode = "create",
  open = false,
  clientIndex = null,
  clientData = null,
  studyIndex = null,
  onClose = () => {},
	confirmSave,
	confirmUpdate,
	clientLoading,
	setClientLoading,
}) => {
  const [clientInfo, setClientInfo] = useState(null);
  const [modalMode, setModalMode] = useState("");

  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft:"18px",
  };

  const saveClient = (e) => {
    e.preventDefault();

    // const { study } = clientInfo;
    if (!clientInfo) {
      toaster("Client data is not valid!","error");
      return;
    }
    if (modalMode === "create") {
      let regInfo = clientInfo;
      // if (studyIndex) {
      //   regInfo = {
      //     ...regInfo,
      //     study: studyIndex,
      //   };
      // }
      confirmSave(regInfo).then((data) => {
        setClientInfo(null)
      })
    } else {
      confirmUpdate(clientIndex, clientInfo)
    }
  };

  useEffect(() => {
    setModalMode(mode);
    setClientInfo(clientData);
  }, [mode, clientData]);

	const additionalProps = {
		className: 'some-class',
		onSubmit: saveClient
	};

  return (
    <MyModal
      modalHeading="Client Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <ClientModalContent>

        {
          clientLoading ?
            <Loading />
            :
            <></>
        }

				<Form {...additionalProps}>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Client Name"
              id="name"
              value={clientInfo?.name || ""}
              onChange={e => setClientInfo({
                ...clientInfo,
                name: e.target.value,
              })}
              required
            />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Identifier"
              id="urlpath_prefix"
              value={clientInfo?.urlpath_prefix || ""}
              onChange={e => setClientInfo({
                ...clientInfo,
                urlpath_prefix: e.target.value,
              })}
              required
            />
          </div>
          <div style={{ marginBottom: "18px" }}>
            <SelectLabel>Sponsors</SelectLabel>
            <ArrayInput 
              value={clientInfo ? clientInfo?.sponsors : []}
              // setValue
              setValue={e => {
                setClientInfo({
                  ...clientInfo,
                  sponsors: e
                })
              }}
            />
          </div>
          <div style={{ marginBottom: "18px" }}>
            <SelectLabel>Secondary Sponsors</SelectLabel>
            <ArrayInput 
              value={clientInfo ? clientInfo?.secondary_sponsors : []}
              // setValue
              setValue={e => {
                setClientInfo({
                  ...clientInfo,
                  secondary_sponsors: e
                })
              }}
            />
          </div>
          <div style={{ marginBottom: "18px" }}>
            <SelectLabel>Export Emails</SelectLabel>
            <ArrayInput 
              value={clientInfo ? clientInfo?.export_emails : []}
              // setValue
              setValue={e => {
                setClientInfo({
                  ...clientInfo,
                  export_emails: e
                })
              }}
            />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Schema Name"
              id="schema_name"
              value={clientInfo?.schema_name || ""}
              onChange={e => setClientInfo({
                ...clientInfo,
                schema_name: e.target.value,
              })}
              required
              />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="Google Analytics URL"
              id="ga_url"
              value={clientInfo?.additional_info?.url || ""}
              onChange={e => setClientInfo({
                ...clientInfo,
                additional_info: {
                  ...clientInfo?.additional_info,
                  url: e.target.value,
                }
              })}
              />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              labelText="DataDog URL"
              id="datadog_url"
              value={clientInfo?.additional_info?.dataDogUrl || ""}
              onChange={e => setClientInfo({
                ...clientInfo,
                additional_info: {
                  ...clientInfo?.additional_info,
                  dataDogUrl: e.target.value,
                }
              })}
              />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <SelectLabel>Disabled Pages</SelectLabel>
            {[
              { key: 'commercial-products', label: 'Commercial Products' },
              { key: 'development-status', label: 'Development Status' },
              { key: 'glossary', label: 'Glossary' },
              { key: 'analytics', label: 'Analytics' },
            ].map(page => (
              <Checkbox
                key={page.key}
                labelText={page.label}
                id={`disable_${page.key}`}
                checked={(clientInfo?.additional_info?.disabledPages || []).includes(page.key)}
                onChange={(checked) => {
                  const current = clientInfo?.additional_info?.disabledPages || [];
                  const updated = checked
                    ? [...current, page.key]
                    : current.filter(p => p !== page.key);
                  setClientInfo({
                    ...clientInfo,
                    additional_info: {
                      ...clientInfo?.additional_info,
                      disabledPages: updated,
                    }
                  });
                }}
              />
            ))}
          </div>


          <div style={{ marginBottom: "18px" }}>
            <SelectLabel>Feature Toggles</SelectLabel>
            <Checkbox
              labelText="Enable Study Page Image"
              id="enable_study_page_image"
              checked={clientInfo?.additional_info?.enableStudyPageImage || false}
              onChange={(checked) => {
                setClientInfo({
                  ...clientInfo,
                  additional_info: {
                    ...clientInfo?.additional_info,
                    enableStudyPageImage: checked,
                  }
                });
              }}
            />
          </div>

          {modalMode === "create" &&
            <div>
              <div style={{ marginBottom: "18px" }}>
                <TextInput
                  labelText="Admin Email"
                  id="admin_email"
                  value={clientInfo?.admin_email || ""}
                  onChange={e => setClientInfo({
                    ...clientInfo,
                    admin_email: e.target.value,
                  })}
                  required
                  />
              </div>

              <div style={{ marginBottom: "18px" }}>
                <PasswordInput
                  labelText="Admin Password"
                  id="admin_password"
                  value={clientInfo?.admin_password || ""}
                  onChange={e => setClientInfo({
                    ...clientInfo,
                    admin_password: e.target.value,
                  })}
                  required
                  />
              </div>
            </div>
          }


          <ModalFooter>
            <Button
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}
            >Cancel</Button>

            <Button
              kind="primary"
              type="submit"
              style={addBtnStyle}
            >{ (modalMode === "create") ? "Create Client" : "Update Client" }</Button>
          </ModalFooter>
        </Form>
      </ClientModalContent>
    </MyModal>
  );
}

export default ClientDetailModal;

const ClientModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const PartWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
`

const InputWrapper = styled.div`
  width: 100%;
`

const InputDisabled = styled.div`
  font-color: #666666;
  font-weight: bold;
  font-size: 1.2em;
`
